import { http } from './config'

export default {
    setToken: (body) => {
        return http.post('cadastro/token', body);
    }
}